module.exports = __webpack_public_path__ + "static/img/index.2e76474.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/index.jpg
// module id = 4igX
// module chunks = 1